import axios from "axios";
import { IIntegrationResponse, IntegrationLogFilters } from "../interfaces/IIntegrationData";
import axiosInstance from "../utils/axiosConfig";

export async function fetchIntegrationLogs(filters: IntegrationLogFilters = {}): Promise<IIntegrationResponse> {
  try {
    const {
      fromDate,
      toDate,
      integrationName,
      status,
      pageNumber = 1,
      pageSize = 15,
    } = filters;

    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (integrationName) params.append("integrationName", integrationName);
    if (status) params.append("status", status);
    params.append("pageNumber", pageNumber.toString());
    params.append("pageSize", pageSize.toString());

    const url = `logs/integrations?${params.toString()}`;
    const response = await axiosInstance.get<IIntegrationResponse>(url);

    if (response.status === 200 && Array.isArray(response.data.Logs)) {
      return {
        Logs: response.data.Logs,
        TotalPages: response.data.TotalPages,
        PageNumber: response.data.PageNumber,
        PageSize: response.data.PageSize
      };
    }

    return {
      Logs: [],
      TotalPages: 1,
      PageNumber: 1,
      PageSize: 15
    };

  } catch (error) {
    console.error("Error fetching integration logs", error);
    return {
      Logs: [],
      TotalPages: 1,
      PageNumber: 1,
      PageSize: 15
    };
  }
}
